module.exports = __webpack_public_path__ + "static/media/10.22f1529b.jpg";